import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../pages/app/protected/firebase';
import { createPortal } from 'react-dom';


const LogoutButton = ({ open }) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('cashmate-remember-me');
      navigate('/logout');
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowConfirm(true)}
        className={`flex items-center ${open ? 'justify-start gap-4 px-4' : 'justify-center px-0'} py-3 rounded-2xl hover:bg-white/10 transition text-gray-300 w-full`}
      >
        {/* Icon */}
        <svg className="w-6 h-6 transform scale-x-[-1]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        {open && <span className="text-md">Logout</span>}
      </button>

      {showConfirm && createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[9999] flex items-center justify-center">
          <div className="bg-[#1f1f1f] p-6 rounded-lg shadow-lg w-[300px] text-center">
            <h3 className="text-white text-lg font-semibold mb-4">Are you sure you want to logout?</h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleLogout}
                className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded text-white"
              >
                Yes
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded text-white"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default LogoutButton;